import React from "react";

const ProductCard = ({product}) => {
  const containerStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
    gap: "20px",
    padding: "20px"
  };

  const productCardStyle = {
    border: "1px solid #ddd",
    borderRadius: "8px",
    padding: "15px",
    textAlign: "center",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
  };

  const imageStyle = {
    height: "200px",
    width: "100%",
    objectFit: "cover",
    borderRadius: "4px"
  };

  const buttonStyle = {
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    padding: "10px 20px",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "16px"
  };

  const handleBuyNow = () => {
    const whatsappUrl = `https://wa.me/+94720735615?text=I%20want%20to%20buy%20${encodeURIComponent(product.name)}`;
    window.open(whatsappUrl, "_blank");
  };

  const image = `${process.env.REACT_APP_POCKETBASE_URL}/api/files/${product.collectionId}/${product.id}/${product.image}`;

  return (
    <div className="m-w-1200px" style={{ maxWidth: "1200px", margin: "0", display: "flex", justifyContent: "center" }}>
      <div style={containerStyle}>
          <div key={product.id} style={productCardStyle}>
            <img
              src={image}
              alt={product.name}
              style={imageStyle}
            />
            <h3 className="text-white">{product.name}</h3>
            <p style={{ fontSize: "20px", fontWeight: "bold" , color:'white'}}>
              Rs {product.price}
            </p>
            <button 
              style={buttonStyle}
              onClick={handleBuyNow}>
              Buy Now
            </button>
          </div>
      </div>
    </div>
  );
};

export default ProductCard;